import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { removeSession } from "../redux/actions/login";
import menu from "../conf/menu";
import CostPhotoProcessComponent from "./helper_components/CostPhotoProcess";
import { manageCostPhotoUpload } from "../redux/actions/cost";
import { useTranslation } from 'react-i18next';
import turkishFlag from '../assets/img/Turkey_flat.png';
import englishFlag from '../assets/img/United-Kingdom_flat.png';
import logoutSVG from '../assets/img/logout.svg';


import {modulesLogo} from "../utils/index"
import apps from "../assets/img/apps.svg"
import globe from "../assets/img/globe.svg"
// LOAD CSS
import "../assets/css/animate.min.css";
import "../assets/css/bootstrap.min.css";
import "../assets/css/demo.css";
import "../assets/css/paper-dashboard.css";
import "../assets/css/themify-icons.css";
import "../assets/css/custom/app.css";
import "../assets/css/custom/sweetalert2.css";
import "../assets/js/paper-dashboard.js";
import "font-awesome/css/font-awesome.min.css";
import { DropdownButton, MenuItem } from "react-bootstrap";
import { change } from "redux-form";
import i18n from "i18next";

import {changeLanguage} from '../redux/actions';

const DashboardComponent = (props) => {
  const { t } = useTranslation();
  const { children, costUploadPhotos, costPhotoProcess, dispatch, permission, isManager, accessToken, language } = props;
  const { location} = children.props
  document.title = t(menu[location.pathname]) + " - masraf.dakika.com.tr";
  const selectedLanguage = (language) => {   
    if(i18n.language != language)
    setIsLanguageModalOpen(false);
    dispatch(changeLanguage({language,accessToken}));
  }
 const [isAppModalOpen, setIsAppModalOpen] = useState(false)
 const [isLanguageModalOpen, setIsLanguageModalOpen] = useState(false)
 const authorities = JSON.parse(window.localStorage.getItem("employeeInfo"))?.sso.authorities || [];
   useEffect(()=> {
    i18n.changeLanguage(language)
   },[])
  return (
    <div>
      <div className="sidebar" data-background-color="white" data-active-color="danger">
        <div className="sidebar-wrapper">
          <div className="logo">
            <Link to="/panel" className="simple-text">
             {t('title')}
             </Link>
          </div>
          <ul className="nav">
            <li id="costPanelPage" className={location.pathname == "/panel" || location.pathname == "/" ? "active" : ""}>
              <Link to="/panel">
                <i className="ti-panel"></i>
                <p>{t('logExpense')}</p>
              </Link>
            </li>
            {
              permission.addCost == "true"
                ?
                <li id="costListPage" className={location.pathname == "/cost" ? "active" : ""}>
                  <Link to="/cost">
                    <i className="ti-credit-card"></i>
                    <p>{t('expenseMonitoring')}</p>
                  </Link>
                </li>
                :
                null
            }
            {
              isManager
                ?
                <li id="managerConfirmationPage" className={location.pathname == "/requests" ? "active" : ""}>
                  <Link to="/requests">
                    <i className="ti-pencil-alt"></i>
                    <p>{t('managerApproval')}</p>
                  </Link>
                </li>
                :
                null
            }
            {
              permission.accountingPage == "true"
                ?
                <li id="accountantConfirmationPage" className={location.pathname == "/accounting" ? "active" : ""}>
                  <Link to="/accounting">
                    <i className="ti-pencil-alt"></i>
                    <p>{t('accountingApproval')}</p>
                  </Link>
                </li>
                :
                null
            }
            {
              permission.reportsPage == "true"
                ?
                <li id="reportPage" className={location.pathname == "/reports" ? "active" : ""}>
                  <Link to="/reports">
                    <i className="ti-files"></i>
                    <p>{t('reports')}</p>
                  </Link>
                </li>
                :
                null
            }
            <li id="helpPage" className={location.pathname == "/help" ? "active" : ""}>
              <Link to="/help">
                <i className="ti-help-alt"></i>
                <p>{t('help')}</p>
              </Link>
            </li>
            <li className="active-pro" id="sidebar-logout">
              <a href="#" id="logout" onClick={(e) => {
                e.preventDefault();
                dispatch(removeSession());
              }}>
                <i><img src={logoutSVG}/></i>
                <p>{t('logOut')}</p>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="wrapper">
        <div className="main-panel">
          <nav className="navbar navbar-default">
            <div className="container-fluid">
              <div className="navbar-header">
               
                <button type="button" className="navbar-toggle">
                  <span className="sr-only">Toggle navigation</span>
                  <span className="icon-bar bar1"></span>
                  <span className="icon-bar bar2"></span>
                  <span className="icon-bar bar3"></span>
                </button>
                <a className="navbar-brand" href="#">{t(menu[location.pathname])}</a>
            
               <button type="button" className="logout-button" onClick={(e) => {
                  e.preventDefault();
                  dispatch(removeSession());
                }}> 
                <img src={logoutSVG} className="logout-icon"/>
                </button>                             
               <button type="button" className="apps-button" > 
               <img src={apps} className="apps-icon" onClick={() => {setIsLanguageModalOpen(false); setIsAppModalOpen(!isAppModalOpen);}}/>
               </button>  
               <button type="button" className="languages-button" > 
               <img src={globe} className="languages-icon" onClick={() => {setIsAppModalOpen(false); setIsLanguageModalOpen(!isLanguageModalOpen);}}/>
               </button>  
                </div>

              <div className="collapse navbar-collapse">
                <ul className="nav navbar-nav navbar-right">
                  <li style={{ position: "relative", display: (costPhotoProcess ? "block" : "none") }}>
                    <a href="#">
                      <i className="ti-upload" style={{ marginRight: "10px" }}></i>
                      <p>Masraf fotoğrafları yükleniyor.</p>
                    </a>
                    <div className="photo-upload-process absolute width-300">
                      <div className="card" style={{ paddingBottom: "10px" }}>
                        <div className="header">
                          <div className="row">
                            <div className="col-md-10">
                              <h5 className="title">{t('uploadedPhotos')}</h5>
                            </div>
                            <div className="col-md-2">
                              <h6 className="title" onClick={() => {
                                dispatch(manageCostPhotoUpload(false));
                              }} style={{ color: "darkred", cursor: "pointer", paddingTop: "8px" }}>X</h6>
                            </div>
                          </div>
                        </div>
                        <div className="content">                        
                          {                            
                            (
                              
                              costUploadPhotos.length > 0
                                ?
                                costUploadPhotos.map((data, key) => {
                                  return <CostPhotoProcessComponent data={data} key={key} />
                                })
                                :
                                null
                            )
                          }
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
          <div>                      
        </div>
        
          {isLanguageModalOpen ?  (
          <div className="languages-button-menu">
            <span className="language-menu-item" onClick={() => selectedLanguage('tr')}> 
                  <img src={turkishFlag}  className="language"  style={{width:"25px", marginRight:"10px"}}/> 
                  <span style={{verticalAlign:"middle"}}>TR</span>
                  <hr/>         
            </span>
            <span className="language-menu-item" onClick={() => selectedLanguage('en')}>                 
                  <img src={englishFlag}  className="language"  style={{width:"25px", marginRight:"10px"}}/> 
                  <span style={{verticalAlign:"middle"}}>EN</span>
                  <hr/>         
            </span>                        
           </div>) :null}
          {isAppModalOpen ?  (
          <div className="apps-button-menu">
            <a href="https://app.dakika.com.tr/payroll/" target="_blank" key="dakika_0" onClick={() => setIsAppModalOpen(false)}>
              <span className="apps-menu-item">                 
                  <img src={modulesLogo["dakika"]} alt="logo" style={{height:"20px", paddingRight:"10px"}}/>
                  <span style={{verticalAlign:"middle"}}>Dakika</span>  
                  <hr/>         
                </span>
              </a>
            {authorities.map((a, i) => 
           (  <a href={a.redirect} target="_blank" key={`${a.title}_${i+1}`} onClick={() => setIsAppModalOpen(false)}>
              <span className="apps-menu-item">                 
                  <img src={modulesLogo[a.logo]} alt="logo" style={{height:"20px", paddingRight:"10px"}}/>
                  <span style={{verticalAlign:"middle"}}>{a.title}</span>  
                  <hr/>         
                </span>
              </a>
            
            )
            )}
           </div>) :null}
         
          {children}
          <footer className="footer">
            <div className="container-fluid">
              <nav className="pull-left">
                <ul>

                  <li>
                    <a href="https://dakika.com.tr/">
                      Dakika
                                </a>
                  </li>
                  <li>
                    <a href="http://datassist.com.tr/">
                      {t('datassistPayrollService')}
                                </a>
                  </li>
                </ul>
              </nav>
              <div className="copyright pull-right">
                &copy; <script>document.write(new Date().getFullYear())</script>
              </div>
            </div>
          </footer>

        </div>
      </div>
    </div>
  )
};

export default DashboardComponent;
